import React from 'react';
import SiteIndexProgress from './site-index-progress';
export const SiteIndexProgressWidget = _ref => {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(SiteIndexProgress, data);
};
export const SITE_INDEXING_PROGRESS_WIDGET = 'SITE_INDEXING_PROGRESS_WIDGET';
//# sourceMappingURL=site-index-progress-widget.js.map